// Channel logo — real brand SVG for social/media channels, a Material icon for
// the non-brand channels (Blog SEO, Landing page, Newsletter, Threads). Vite
// imports .svg as a URL string; we render via <img> so the brand colors show.

import ArticleIcon from '@mui/icons-material/Article';
import WebIcon from '@mui/icons-material/Web';
import EmailIcon from '@mui/icons-material/Email';
import type { ContentChannel } from '@traaker/shared';
import { CHANNEL_COLOR } from './channels';

import facebook from '../../assets/media/facebook.svg';
import instagram from '../../assets/media/instagram.svg';
import linkedin from '../../assets/media/linkedIn.svg';
import medium from '../../assets/media/medium.svg';
import quora from '../../assets/media/quora.svg';
import reddit from '../../assets/media/reddit.svg';
import tiktok from '../../assets/media/tiktok.svg';
import x from '../../assets/media/x.svg';
import youtube from '../../assets/media/youTube.svg';
import threads from '../../assets/media/threads.svg';

// Channels that have a real brand SVG.
const LOGO_SRC: Partial<Record<ContentChannel, string>> = {
  facebook,
  instagram,
  linkedin_post: linkedin,
  linkedin_article: linkedin,
  medium,
  quora,
  reddit,
  tiktok,
  x_post: x,
  x_thread: x,
  youtube,
  threads,
};

// Channels without a brand logo → a themed Material icon.
const ICON_FALLBACK: Partial<Record<ContentChannel, typeof ArticleIcon>> = {
  blog_seo: ArticleIcon,
  landing_page: WebIcon,
  newsletter: EmailIcon,
};

export function ChannelLogo({ channel, size = 16 }: { channel: ContentChannel; size?: number }) {
  const src = LOGO_SRC[channel];
  if (src) {
    return <img src={src} alt="" width={size} height={size} style={{ display: 'block', objectFit: 'contain' }} />;
  }
  const Icon = ICON_FALLBACK[channel] || ArticleIcon;
  return <Icon sx={{ fontSize: size, color: CHANNEL_COLOR[channel] }} />;
}
